<template>
  <div class='cm-truncated-text' v-bind="$attrs">
    <div
      class='cm-truncated-text__truncator'
      :style="{
        webkitLineClamp: maxLines,
        height: `${snappedHeight}px`
      }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
  // references to width / height properties are from here
  import ResizeObserverMixin from './mixins/resize-observer';

  export default {
    mixins: [ResizeObserverMixin],

    props: {
      lines: { type: Number, }
    },

    data () {
      return {
        maxLines: null,
        snappedHeight: 0,
      }
    },

    watch: {
      height (nextValue) {
        const textBox = this.$el;
        const style = window.getComputedStyle(textBox)
        const lineHeight = parseInt(style.getPropertyValue("line-height"));

        this.maxLines = Math.max(2, this.lines || Math.floor(this.height / lineHeight))
        this.snappedHeight = this.maxLines * lineHeight
      },
    }
  }
</script>

<style lang='scss' scoped>

  .cm-truncated-text {
    overflow: hidden;
  }
  .cm-truncated-text__truncator {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

</style>



// WEBPACK FOOTER //
// app/javascript/components/cm-truncated-text.vue?1e1b7a25